module.exports = __webpack_public_path__ + "media/bootstrap-icons/cart-check-cce66b59.svg";